/* eslint-disable no-unused-vars */
import BreakMinuteListOption from './breakMinuteListOption.js'

/**
 * Class representing a default break selection option.
 */
export default class DefaultBreakSelectionOption {
  /**
   * Create a DefaultBreakSelectionOption.
   * @param {BreakMinuteListOption} option - Contains the default break option.
   * @param {boolean} isNewOption - Indicates that the break option should be inserted to the list.
   * @param {number} [index] - The position in the breaks list the option will be inserted after. Optional unless isNewOption = true.
   */
  constructor(option, isNewOption = false, index = undefined) {
    /**
     * @property {BreakMinuteListOption} option - Contains the default break option.
     */
    this.option = option

    /**
     * @property {boolean} isNewOption - Indicates that the break option should be inserted to the list.
     */
    this.isNewOption = isNewOption

    /**
     * @property {number} [index] - The position in the breaks list the option will be inserted after. Optional unless isNewOption = true.
     */
    this.index = isNewOption ? index : undefined
  }
}
